import React from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import useGlobalModel from "./model/globalModel";
import { Login } from "./views/login/Login";
import Index from "./layout";


function App() {
    const { user: { token } } = useGlobalModel();

    return (
        <Switch>
            <Route path="/login" component={() => <Login />} />
            <Route path="/" render={
                () => token ? <Index /> : <Redirect to="/login" />}
            />
            {/* <Route path="/" render={
                () => <Index />}
            /> */}
        </Switch>
    );
}

export default App;
